import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=0c1ea920&scoped=true"
import script from "./SelectTab.vue?vue&type=script&lang=js"
export * from "./SelectTab.vue?vue&type=script&lang=js"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=0c1ea920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ea920",
  null
  
)

export default component.exports